module.exports = "/packs/images/our-technology/mobile/hero@2x-886c3bd80b62576f530bebb4cf7392a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/our-technology/mobile/hero@2x.jpg
// module id = 1784
// module chunks = 0